import { createAction } from '@reduxjs/toolkit'

import { ISnapMetricsResponse, SnapMetricsActionTypes } from './types'

export const fetchSnapMetrics = createAction<number>(SnapMetricsActionTypes.FETCH_REQUEST)

export const fetchSnapMetricsSuccess = createAction(
  SnapMetricsActionTypes.FETCH_SUCCESS,
  (metrics: ISnapMetricsResponse, campaignId: number) => ({
    payload: {
      metrics,
      campaignId,
    },
  }),
)

export const fetchSnapMetricsError = createAction<any>(SnapMetricsActionTypes.FETCH_ERROR)
